<template>
  <modal-dialog :isFixed="true" @close="$emit('close')">
    <div slot="header" style="border-bottom: 1px solid #eee; margin: 0 -10px" class>
      <v-layout wrap row class="mb-0 mt-2 ml-2 mr-2">
        <v-flex xs6 sm9>
          <div class="form-control">
            <input type="text" v-model="search" :placeholder="$t('Search')" />
          </div>
        </v-flex>
        <v-flex xs6 sm3></v-flex>
      </v-layout>
    </div>

    <div slot="body">
      <div v-if="loading" class="pt-2 pb-2">
        <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
      </div>
      <template v-else>
        <div
          class="z-border-red pa-2 ma-2"
          v-for="intent in filterIntent"
          :key="'intent_' + intent.id"
        >
          <v-layout wrap row class="mb-0">
            <v-flex xs6>
              {{ intentLabel(intent.intentname) }}
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <label class="toggle-switch small" style="vertical-align: bottom">
                <input
                  type="checkbox"
                  :checked="intent.linenoti_status"
                  @change="onChangeLinenotifyStatus(intent.id)"
                />
                <span class="toggle-slider lever round"></span>
              </label>
            </v-flex>
          </v-layout>
          <v-layout wrap style="border-top: 1px solid #eee" class="mt-2 pt-1">
            <v-flex xs12>
              <div class="form-control">
                <input
                  type="text"
                  v-model="intent.linenoti_text"
                  :placeholder="$t('Message')"
                  class="mb-0"
                  maxlength="250"
                  @change="onChangeLinenotifyText(intent.id)"
                />
              </div>
            </v-flex>
          </v-layout>
        </div>
      </template>
    </div>

    <div slot="footer" style="border-top: 1px solid #eee" class="text-xs-center">
      <v-btn outline color="grey" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="onSaveLineNotify">{{ $t('Save') }}</v-btn>
    </div>
  </modal-dialog>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { async } from 'q'
export default {
  props: {
    type: {
      default: 'conversation'
    }
  },
  data: function () {
    return {
      loading: true,
      search: '',
      intents: [],
      default_intent: undefined
    }
  },
  components: {
    ModalDialog,
    ScaleLoader
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntent: function () {
      var vm = this
      if (vm.search != '') {
        return vm.intents.filter(function (el) {
          return el.intentname.toLowerCase().includes(vm.search.toLowerCase())
        })
      } else {
        return vm.intents
      }
    }
  },
  mounted: function () {
    var vm = this
    vm.loading = true
    vm.getIntent().then(function () {
      vm.loading = false
    })
  },
  methods: {
    onChangeLinenotifyStatus: function (id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function (el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
        vm.intents[findIndex].linenoti_status = !vm.intents[findIndex].linenoti_status
      }
    },
    onChangeLinenotifyText: function (id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function (el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
      }
    },
    onSaveLineNotify: async function () {
      let vm = this
      vm.$store.dispatch('loading')
      vm.saveAllLineNotify().then(function () {
        vm.$store.dispatch('loading')
        vm.$emit('close')
      })
    },
    saveAllLineNotify: async function () {
      let vm = this
      try {
        if (vm.filterIntent) {
          var result = await Promise.all(
            vm.filterIntent.map((intent) => vm.precessSaveLineNotify(intent))
          )
        }
        return result
      } catch (error) {
        return error
      }
    },
    precessSaveLineNotify: async function (intent) {
      return await this.saveLineNotify(intent)
    },
    saveLineNotify: function (intent) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (intent.isEdit) {
          let data = {
            pageid: vm.selectedBot.pageid,
            intentname: intent.intentname,
            q_type: intent.q_type,
            q_val: intent.q_val,
            a_type: 'json',
            a_val: intent.a_val.replace(/ /gim, ' '),
            context_in: intent.context_in != null ? intent.context_in : '',
            context_out: intent.context_out != null ? intent.context_out : '',
            quick_reply: intent.quick_reply,
            postidlist: intent.postidlist,
            isShow: true,
            userstatus: intent.userstatus,
            usertags: intent.usertags,
            linenoti_status: intent.linenoti_status,
            linenoti_text: intent.linenoti_text
          }

          data['id'] = intent.id

          api.editIntent(data, function (error, response) {
            if (error) {
              reject(error)
            }

            resolve()
          })
        } else {
          reject()
        }
      })
    },
    getIntent: function () {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }

      return new Promise((resolve, reject) => {
        api.getIntent(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            var default_intent = null
            var isFoundDefault = false
            $.each(response.data, function (index, val) {
              var intent = val
              intent.isEdit = false
              intent.ableToDelete = true
              if (vm.type == 'conversation' && intent.context_in != 'comment') {
                if (intent.intentname == '{default}') {
                  isFoundDefault = true
                  intent.ableToDelete = false
                  intent.intentname = '{default}'
                  default_intent = intent
                } else if (intent.intentname == '{welcome}') {
                  intent.intentname = '{welcome}'
                  vm.intents.push(intent)
                } else {
                  vm.intents.push(intent)
                }
              } else if (vm.type == 'replycomment' && intent.context_in == 'comment') {
                if (intent.intentname == '{default_comment_to_inbox}') {
                  isFoundDefault = true
                  intent.ableToDelete = false
                  intent.intentname = '{default_comment_to_inbox}'
                  default_intent = intent
                } else {
                  vm.intents.push(intent)
                }
              }
            })

            if (!isFoundDefault) {
              if (vm.type == 'conversation') {
                vm.intents.push({
                  intentname: '{default}',
                  q_type: 'text',
                  a_type: 'json',
                  q_val: '',
                  a_val: '[[]]',
                  context_in: '',
                  context_out: '',
                  ableToDelete: false,
                  isEdit: false
                })
              } else {
                vm.intents.push({
                  intentname: '{default_comment_to_inbox}',
                  q_type: 'text',
                  a_type: 'json',
                  q_val: '{default}',
                  a_val: [[]],
                  context_in: '',
                  context_out: '',
                  ableToDelete: false,
                  isEdit: false,
                  pageidlist: '',
                  userstatus: '',
                  usertags: ''
                })
              }
            } else {
              vm.intents.push(default_intent)
            }
            resolve()
          } else {
            reject()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/ManageSingleLineNotify.vue